var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPieChart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.3 10.33c.239 0 .358 0 .454.052.08.044.154.126.189.21.043.1.032.208.01.423a6.87 6.87 0 1 1-7.522-7.522c.215-.022.323-.032.424.01a.46.46 0 0 1 .21.19c.052.096.052.215.052.453v5.007-.372a1.55 1.55 0 0 0 1.55 1.548H15.3"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.899 2.364c0-.238 0-.357.052-.453a.46.46 0 0 1 .21-.189c.1-.043.208-.032.424-.01a6.87 6.87 0 0 1 6.15 6.15c.022.215.032.323-.01.424a.46.46 0 0 1-.19.21c-.096.052-.215.052-.453.052h-5.496c-.24 0-.361 0-.453-.047a.43.43 0 0 1-.188-.187C10.9 8.222 10.9 8.1 10.9 7.86z"
})));
SvgPieChart.displayName = "SvgPieChart";
export { SvgPieChart as ReactComponent };
export default SvgPieChart;